import type { MultiSelectProps} from '@mantine/core';
import {MultiSelect} from '@mantine/core';
import React, {useMemo} from 'react';
import type {GetProjectListRequest} from 'src/api/ProactApiClient';
import {useGetProjectSelectOptionsQuery} from 'src/redux/queries/project';

export interface ProjectMultiSelectProps
  extends Omit<MultiSelectProps, 'data' | 'value' | 'onChange'> {
  queryOptions?: Partial<GetProjectListRequest>;
  value: string[];
  onChange: (value: string[]) => void;
}

export const ProjectMultiSelect: React.FC<ProjectMultiSelectProps> = React.memo(
  ({queryOptions, value, onChange, ...other}) => {
    const {data, isLoading} = useGetProjectSelectOptionsQuery({
      ...queryOptions,
      start: 0,
      length: 100,
      sortColumn: queryOptions?.sortColumn ?? 'name',
      sortDirection: queryOptions?.sortDirection ?? 'asc',
    });

    const options = useMemo(
      () =>
        (data?.data ?? []).map(project => ({
          value: String(project.id),
          label: project.label ?? '',
        })),
      [data?.data]
    );

    return (
      <MultiSelect
        {...other}
        data={options}
        value={value}
        onChange={onChange}
        disabled={isLoading || other.disabled}
        clearable
        searchable
        maxDropdownHeight={200}
      />
    );
  }
);
